import React from 'react';
import { Button } from '@progress/kendo-react-buttons';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { useGlobalizationContext, useTranslation, useUiAdminConfigsContext } from '@cs-cms/state-management';
import {
  ABOUT_ADDED_TEXT,
  CpsAboutState,
  CpsReportIssueState,
  CPS_UI_ADMIN_CONFIG_TYPE,
  REPORT_ISSUE_BUTTON_LABEL
} from '@cs-cms/types';

interface AboutDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

export const AboutDialog: React.FC<AboutDialogProps> = ({ isOpen, onClose }) => {
  const { uiAdminConfigState } = useUiAdminConfigsContext();
  const { selectedLocale } = useGlobalizationContext();
  const { translate } = useTranslation(selectedLocale);
  const aboutConfig = uiAdminConfigState[CPS_UI_ADMIN_CONFIG_TYPE.ABOUT] as CpsAboutState | undefined;
  const reportIssueState = uiAdminConfigState.reportIssue as CpsReportIssueState;

  const isPlainHtml = typeof aboutConfig === 'string';
  const aboutState = !isPlainHtml ? aboutConfig : undefined;

  return (
    <>
      {isOpen && (
        <Dialog title={translate('custom.settings.about')} onClose={onClose} className="aboutDialog">
          <>
            {isPlainHtml ? (
              <div dangerouslySetInnerHTML={{ __html: aboutConfig as string }} />
            ) : (
              <>
                <h3>
                  {aboutState?.system || ''} {aboutState?.version || ''}
                </h3>
                <div>{aboutState?.copyright || ''}</div>
                {aboutState?.info && <div dangerouslySetInnerHTML={{ __html: aboutState.info }} />}
              </>
            )}

            <>
              {aboutConfig?.info && <div dangerouslySetInnerHTML={{ __html: aboutConfig.info }} />}
              <p>{ABOUT_ADDED_TEXT}</p>
              <Button
                themeColor="dark"
                onClick={() =>
                  window.open(
                    `mailto:${reportIssueState.emailRecipient || ''}?subject=${reportIssueState.emailSubject || ''}&body=${reportIssueState.emailBody || ''}`
                  )
                }
              >
                {REPORT_ISSUE_BUTTON_LABEL}
              </Button>
            </>
          </>

          <DialogActionsBar layout="center">
            <Button onClick={onClose} themeColor={'primary'} size={'small'}>
              {translate('custom.common.close')}
            </Button>
          </DialogActionsBar>
        </Dialog>
      )}
    </>
  );
};
